<template>
	<v-dialog v-model="visible_local" :max-width="maxWidth">
		<div class="link-container pa-3">
			<div class="">Link</div>
			<v-text-field
				class="mx-2 link-text"
				id="copylink"
				:value="linkUrl"
				background-color="#FFFFFF"
				:color="color"
				outlined
				dense
				hide-details
				readonly
			>
			</v-text-field>
			<v-btn depressed :color="'#00AAFD'" class="white--text text-capitalize" @click="onCopyLink()">
				<v-icon small class="mr-2">mdi-content-copy</v-icon>
				<span>Copy</span>
			</v-btn>
		</div>
	</v-dialog>
</template>
<script>
export default {
	name: 'TaskLinkDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: Number,
			default: 500
		},
		color: {
			type: String,
			default: ''
		},
		linkUrl: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			visible_local: this.visible,
		}
	},
	watch: {
		visible_local() {
			if (!this.visible_local) {
				this.$emit('close');
			}
		}
	},
	methods:{
		onCopyLink() {
			navigator.clipboard.writeText(this.linkUrl).then(() => {
				/* clipboard successfully set */
				this.$emit('copy-link', true);
				
			}, () => {
				/* clipboard write failed */
				this.$emit('copy-link', false);
				
			});
		}
	}
}
</script>
<style lang="scss" scoped>
.link-container {
  display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
  align-items: center;
	background: #FFFFFF;
}
.link-text {
  // width: 200px; 
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis;
}
::v-deep {
  .v-text-field input {
    width: 300px;
    white-space: nowrap; 
    overflow: hidden; 
    text-overflow: ellipsis;
  }
}
</style>